import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import { FC } from "react";

export const ForgetPasswordIconSvg = () => (
  <svg
    width="19"
    height="16"
    viewBox="0 0 19 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9998 16C9.97177 16 8.98743 15.8093 8.04677 15.428C7.1061 15.0467 6.25943 14.5133 5.50677 13.828L6.24077 13.116C6.89943 13.7067 7.62277 14.1683 8.41077 14.501C9.19877 14.8337 10.0618 15 10.9998 15C12.9464 15 14.5998 14.32 15.9598 12.96C17.3198 11.6 17.9998 9.94667 17.9998 8C17.9998 6.06667 17.3164 4.41667 15.9498 3.05C14.5831 1.68333 12.9331 1 10.9998 1C9.06643 1 7.41643 1.68333 6.04977 3.05C4.6831 4.41667 3.99977 6.06667 3.99977 8V9.387L6.15177 7.234L6.86577 7.923L3.49977 11.288L0.134766 7.923L0.847766 7.235L2.99977 9.412V8C2.99977 6.89067 3.20843 5.85133 3.62577 4.882C4.0431 3.91267 4.61443 3.06533 5.33977 2.34C6.0651 1.61467 6.91243 1.04333 7.88177 0.626C8.8511 0.208667 9.89043 0 10.9998 0C12.1091 0 13.1484 0.208667 14.1178 0.626C15.0871 1.04333 15.9348 1.61467 16.6608 2.34C17.3868 3.06533 17.9578 3.91267 18.3738 4.882C18.7898 5.85133 18.9984 6.89067 18.9998 8C18.9998 10.218 18.2211 12.106 16.6638 13.664C15.1064 15.222 13.2184 16.0007 10.9998 16ZM8.11577 11.77V7H9.11577V5.885C9.11577 5.36033 9.29877 4.915 9.66477 4.549C10.0308 4.183 10.4758 4 10.9998 4C11.5238 4 11.9691 4.183 12.3358 4.549C12.7024 4.915 12.8851 5.36033 12.8838 5.885V7H13.8838V11.77H8.11577ZM9.88477 7H12.1148V5.885C12.1148 5.57567 12.0064 5.31233 11.7898 5.095C11.5731 4.87767 11.3098 4.76933 10.9998 4.77C10.6898 4.77067 10.4264 4.87933 10.2098 5.096C9.9931 5.31267 9.88443 5.576 9.88377 5.886L9.88477 7Z"
      fill="currentColor"
    />
  </svg>
);

export const ForgetPasswordIcon: FC<Partial<CustomIconComponentProps>> = (
  props
) => <Icon component={ForgetPasswordIconSvg} {...props} />;

export default ForgetPasswordIcon;

ForgetPasswordIcon.displayName = "ForgetPasswordIcon";
